<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!-- Contenet page started-->
  <div class="row">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Reports</a></li>
          <li><a>Farm</a></li>
          <li><a>Material Movement Report</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
    </div>
    <!-- breadcrumb End -->
    <div class="block">
      <div class="page-header">
        <span class="page-header__title">Material Movement Report</span>
      </div>
      <div class="Reports_form_div">
        <form class="form-horizontal" id="myForm" role="form" novalidate [formGroup]="registerForm">
          <div class="reports-form-container" (clickOutside)="isDropdownOpen = false">
            <mat-form-field appearance="outline" class="w-100 custom-select" *ngIf="loginPersonType == 'EMPLOYEE'">
              <mat-label>Search Business Name</mat-label>
              <!-- search box powered by mat‑autocomplete -->
              <input matInput type="text" id="businessname" autocomplete="off" formControlName="businessfield"
                     placeholder="Search business" (keyup)="filterBusinesses($event)"
                     (click)="isDropdownOpen = true" (focus)="filteredOptions = businessEntities"
                     [matAutocomplete]="businessAuto"/>
              <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                <mat-option *ngFor="let option of filteredOptions" [value]="option">
                  {{ option.businessName }}
                </mat-option>
              </mat-autocomplete>
              <mat-hint *ngIf="f.businessfield.invalid"><i>Select business</i></mat-hint>
              <mat-hint *ngIf="f.businessfield.valid"><i>Business selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.businessfield.touched || f.businessfield.dirty) && f.businessfield.errors">
                <i *ngIf="f.businessfield.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Farm Site</mat-label>
              <mat-select id="location" formControlName="locationField" name="location"
                          (click)="isDropdownOpen = false"
                          [(ngModel)]="onHandQuantity.farmSiteId">
                <mat-option value="undefined" disabled>Select Farm site</mat-option>
                <mat-option *ngFor="let farmsite of farmSites" [value]="farmsite.id">
                  {{ (farmsite?.farmNameAtLocation) }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="f.locationField.invalid"><i>Select farm site</i></mat-hint>
              <mat-hint *ngIf="f.locationField.valid"><i>Farm site selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.locationField.touched || f.locationField.dirty) && f.locationField.errors">
                <i *ngIf="f.locationField.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
          </div>
        </form>
        <div class="buttons-div reports_search_div">
          <div class="transactions-button-container" (click)="getAllMMRegisterData()">
            <button class="transaction-submit-button" [disabled]="submitButtonDisabled">
              <span class="icon"><img src="../../../../../../assets/images/New_Icons/search-icon.svg"></span>
              <span class="text">Search</span>
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="responseLoader">
        <div class="adjust loader-container">
          <div class="loader2"></div>
        </div>
      </div>
      <!-- START BASIC TABLE SAMPLE -->
    </div>
    <div class="block">
      <div class="reports_block" *ngIf="!responseLoader && isSubmitClicked">
        <div class="reports-toolbar">
          <!-- Search -->
          <div class="reports-toolbar__search">
            <img src="assets/images/New_Icons/search-icon.svg" alt="Search Icon" />
            <input type="text" (keyup)="onFiltersApplied()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by item name"/>
            <button *ngIf="search !== ''" type="button" (click)="clearFilters('search')" class="reports-toolbar__clear-btn" style="top: 15px" title="Clear search">&times;</button>
          </div>
          <!-- Filters -->
          <div class="reports-toolbar__select-wrapper">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Filter by Date Range</mat-label>
              <mat-date-range-input [rangePicker]="picker" [formGroup]="dateRangeForm" [max]="maxDate" (focus)="picker.open()" (click)="picker.open()">
                <input matStartDate placeholder="Start date" formControlName="start" readonly />
                <input matEndDate placeholder="End date" formControlName="end" readonly />
              </mat-date-range-input>
              <!-- Dynamic icon: calendar or clear (×) -->
              <button mat-icon-button matSuffix [ngClass]="dateFilterApplied ? 'reports-toolbar__clear-btn' : ''"
                      [ngStyle]="{ 'z-index': 1000, 'position': 'relative', 'background': 'none', 'border': 'none', 'box-shadow': 'none', 'outline': 'none'}"
                      (click)="dateFilterApplied ? clearDateRange() : picker.open()"
                      aria-label="Toggle date">
                <!-- Show normal calendar icon if no filter applied -->
                <mat-icon *ngIf="!dateFilterApplied">calendar_today</mat-icon>
                <!-- Show × if filter is applied -->
                <span *ngIf="dateFilterApplied" style="font-size: 20px; font-weight: bold;">&times;</span>
              </button>
              <mat-date-range-picker #picker (closed)="onPickerClosed()"></mat-date-range-picker>
            </mat-form-field>
          </div>
          <!-- Actions -->
          <div class="reports-toolbar__actions" *ngIf="onHandQuantities?.length > 0 || tableLoader">
            <img src="assets/images/New_Icons/excel-download-icon.svg" title="Excel export" (click)="!tableLoader && exportExcel()" [style.cursor]="tableLoader ? 'not-allowed' : 'pointer'" />
            <img src="assets/images/New_Icons/expand-icon.svg" title="Zoom In" (click)="!tableLoader && openFullScreen()" [style.cursor]="tableLoader ? 'not-allowed' : 'pointer'" />
          </div>
        </div>

        <!-- Table loader when date filter is changed -->
        <div *ngIf="tableLoader">
          <div class="adjust loader-container">
            <div class="loader2"></div>
          </div>
        </div>

        <div class="table-responsive" id="zoomView" *ngIf="!tableLoader && onHandQuantities?.length > 0">
          <table class="table table-bordered table-responsive-md table-striped">
            <thead>
            <tr>
              <th></th>
              <th colspan="6"></th>
              <th colspan="3">INWARD (+)</th>
              <th colspan="3">OUTWARD (-)</th>
            </tr>
            <tr>
              <th>S.No</th>
              <th class="handSymbol" (click)="sortingTanks('transaction_date', mmregisterAsc, 'mmregisterAsc')">
                Transaction date
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':mmregisterAsc,'glyphicon-chevron-down':!mmregisterAsc}"></span>
              </th>
              <th>ITEM</th>
              <th>OPENING STOCK</th>
              <th>PURCHASE</th>
              <th>BALANCE MIGRATION</th>
              <th>REVERSAL</th>
              <th>MISCELLANEOUS</th>
              <th>TRANSFER/RETURN</th>
              <th>ISSUES</th>
              <th>TOTAL CONSUMPTION</th>
              <th>ON HAND</th>
              <th>VALUE (INR)</th>
            </tr>
            </thead>
            <tbody>
            <tr
              *ngFor="let list of onHandQuantities; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ list && list.transaction_date | date:"dd MMM yyyy" }}</td>
              <td>{{ list && list.item_name }} <span
                *ngIf="list && list.sub_type">-</span> {{ list && list.sub_type }}
              </td>
              <td class="number-align-right">{{ list && list.opening_stock | currencyFormat }} {{ list.name }}</td>
              <td class="number-align-right">{{ list && list.purchase | currencyFormat }} {{ list.name }}</td>
              <td class="number-align-right">{{ list && list.balanceMigration | currencyFormat }} {{ list.name }}</td>
              <td class="number-align-right">{{ list && list.reversal | currencyFormat }} {{ list.name }}</td>
              <td class="number-align-right">{{ list && (list.miscellaneous | currencyFormat) }} {{ list.name }}</td>
              <td class="number-align-right">{{ list && (list.transfer | currencyFormat) }} {{ list.name }}</td>
              <td class="number-align-right">{{ list && (list.issues | currencyFormat) }} {{ list.name }}</td>
              <td class="number-align-right">{{ list && list.total_consumption | currencyFormat }} {{ list.name }}
              </td>
              <td class="number-align-right">{{ list && list.closing | currencyFormat }} {{ list.name }}</td>
              <td class="number-align-right">{{ list && (list.total_cost | currencyFormat) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="listLoader && !tableLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <!-- Show when filters or search applied but no matching results -->
        <div *ngIf="!tableLoader && onHandQuantities?.length <= 0 && isSubmitClicked && (search || dateFilterApplied)" class="noDataFoundMessage">
          {{ search && dateFilterApplied ?
          'No items match your search and filter' :
          (search ? 'No items match your search' : 'No items match your filter') }}
        </div>

      </div>
      <!-- Show when no data available and no filters/search applied -->
      <div class="reports_block" *ngIf="!responseLoader && !tableLoader && onHandQuantities?.length <= 0 && isSubmitClicked && !(search || dateFilterApplied)">
        <div class="noDataFoundMessage">Data Not Available</div>
      </div>

    </div>
  </div>
</div>
